import React, { useContext } from 'react';
import SectionHeader from 'commonComponents/Headers/SectionHeader/SectionHeader';
import PhotoAndContact from '../Person/PhotoAndContact/PhotoAndContact';
import NameAndPosition from '../Person/NameAndPosition/NameAndPosition';
import { WunderAgentsContext } from '../TeamPage';
import styles from './WunderAgents.module.scss';

const WunderAgents = ({ departments }) => {
  const { title } = useContext(WunderAgentsContext);

  return (
    <section className={ styles.WunderAgents }>
      <SectionHeader
        title={ title }
        anchor='wunder-agents'
      />
      {
        departments && departments
          .sort((a, b) => +a.positionNumber - +b.positionNumber)
          .map((department, i) =>
            <Department
              { ...department }
              key={ i }
              icon={ department.iconUrl }
            />
          )
      }
    </section>
  );
};

const Department = ({ icon, title, isSmartType, description, team, subheadline }) => {
  const sortedTeam = team && team.sort((a, b) => +b.is_teamlead - +a.is_teamlead )
    .map(( employee, key ) => <Employee key={ key } employee={ employee } />);

  return (
    <div className={ styles.Department }>
      <aside>
        <div className={ styles.titleContainer }>
          <h4 className={ isSmartType ? styles.smart : null }>
            { isSmartType &&
              <span className={ styles.icon }>
                <img src={ icon } width="27"
                  height="27"
                />
              </span>
            }
            <span className={ styles.text }>{ title }</span>
          </h4>
          { subheadline && <p className={ styles.subheadline }>{ subheadline }</p> }
        </div>
        <p className={ styles.description }>{ description }</p>
      </aside>
      <div className={ styles.teamMembers }>
        { sortedTeam }
      </div>
    </div>
  );
};

const Employee = ({ employee }) => {
  const { name, position, email } = employee;

  return (
    <div className={ styles.employeeCard }>
      <PhotoAndContact
        employee={ employee }
        contacts={[{ link: `mailto:${email}` }]}
      />
      <NameAndPosition name={ name } position={ position } />
    </div>
  );
};
 
export default WunderAgents;
